import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
  Modal,
} from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

//redux
import { useSelector, useDispatch } from "react-redux"

import { withRouter } from "react-router-dom"

import avatar from "../../assets/images/users/user-tmp.png"
// actions
import {
  loadUser,
  resetUserFlag,
  editUser,
  editPasswordUser,
} from "../../store/actions"
import { userModel } from "helpers/models/UserModel"
import { toast } from "react-toastify"
import { userConstants } from "constants/user"

const Profile = props => {
  const dispatch = useDispatch()
  const [modelUser, setModelUser] = useState({ ...userModel })
  const { currentUser, userError, userSuccess, loadingSubmit } = useSelector(
    state => ({
      currentUser: state.Login.user,
      userError: state.Users.error,
      userSuccess: state.Users.success,
      loadingSubmit: state.Users.loadingSubmit,
    })
  )
  const [mode, setMode] = useState(userConstants.OPERATION.EDIT)

  useEffect(() => {
    dispatch(loadUser())
  }, [])

  useEffect(() => {
    if (userSuccess) {
      toast.dismiss()
      toast.success(userSuccess)
      setModalUser(false)
      dispatch(resetUserFlag())
      dispatch(loadUser())
    }
  }, [userSuccess])

  const [modalUser, setModalUser] = useState(false)

  function toggleModalUser() {
    resetUser()
    dispatch(resetUserFlag())
    setModalUser(!modalUser)
  }

  function handleValidSubmit(event, values) {
    switch (mode) {
      case userConstants.OPERATION.EDIT:
        dispatch(editUser(modelUser))
        break
      case userConstants.OPERATION.EDIT_PASSWORD:
        dispatch(editPasswordUser(modelUser))
        break
      default:
        setModalUser(false)
        resetUser()
        dispatch(resetUserFlag())
    }
  }

  function handleEditUser() {
    setMode(userConstants.OPERATION.EDIT)
    toggleModalUser()
    setModelUser({ ...currentUser, password: "", re_password: "" })
  }

  function handleEditPasswordUser() {
    setMode(userConstants.OPERATION.EDIT_PASSWORD)
    toggleModalUser()
    setModelUser({ ...currentUser, password: "", re_password: "" })
  }

  function resetUser() {
    setModelUser({ ...userModel })
  }

  function titleModal() {
    switch (mode) {
      case userConstants.OPERATION.EDIT:
        return "Edit User"
      case userConstants.OPERATION.EDIT_PASSWORD:
        return "Edit Password"
      default:
        return ""
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Hast | User Profile </title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex flex-wrap mt-2 mb-3">
            <h4 className="font-size-16">Profile</h4>
            <div style={{ marginLeft: "auto" }}>
              <Button
                color="primary"
                outline
                className="me-2"
                onClick={() => {
                  handleEditPasswordUser()
                }}
              >
                Edit Password
              </Button>
              <Button
                color="primary"
                outline
                onClick={() => {
                  handleEditUser()
                }}
              >
                Edit Profile
              </Button>
            </div>
            <Modal isOpen={modalUser} centered={true}>
              <div className="modal-header">
                <h5 className="modal-title mt-0">{titleModal()}</h5>
                <button
                  type="button"
                  onClick={() => {
                    setModalUser(false)
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  disabled={loadingSubmit}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {userError ? <Alert color="danger">{userError}</Alert> : null}
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                  }}
                >
                  <div className="form-group mb-3">
                    <AvField
                      name="email"
                      label="Email"
                      value={modelUser.email}
                      className="form-control mb-3"
                      placeholder="Enter Email"
                      type="text"
                      disabled={
                        mode === userConstants.OPERATION.EDIT ||
                        mode === userConstants.OPERATION.EDIT_PASSWORD
                      }
                      onChange={e =>
                        setModelUser({
                          ...modelUser,
                          email: e.target.value,
                        })
                      }
                    />
                    {mode === userConstants.OPERATION.EDIT_PASSWORD && (
                      <>
                        <AvField
                          name="password"
                          label={mode === "ADD" ? "Password" : "New Password"}
                          value={modelUser.password}
                          className="form-control mb-3"
                          placeholder={
                            mode === "ADD"
                              ? "Enter Password"
                              : "Enter New Password"
                          }
                          type="password"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              password: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="re_password"
                          label={
                            mode === "ADD" ? "Re-Password" : "Re-New Password"
                          }
                          value={modelUser.re_password}
                          className="form-control mb-3"
                          placeholder={
                            mode === "ADD"
                              ? "Enter Re-Password"
                              : "Enter Re-New Password"
                          }
                          type="password"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              re_password: e.target.value,
                            })
                          }
                        />
                      </>
                    )}
                    {mode === userConstants.OPERATION.EDIT && (
                      <>
                        <AvField
                          name="first_name"
                          label="First Name"
                          value={modelUser.first_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter First Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              first_name: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="last_name"
                          label="Last Name"
                          value={modelUser.last_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter Last Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              last_name: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="tel"
                          label="Tel."
                          value={modelUser.tel || ""}
                          className="form-control mb-3"
                          placeholder="Enter Tel."
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              tel: e.target.value,
                            })
                          }
                        />
                        <AvField
                          name="agent_name"
                          label="Agent Name"
                          value={modelUser.agent_name || ""}
                          className="form-control mb-3"
                          placeholder="Enter Agent Name"
                          type="text"
                          onChange={e =>
                            setModelUser({
                              ...modelUser,
                              agent_name: e.target.value,
                            })
                          }
                        />
                      </>
                    )}
                  </div>
                  <div className="mb-2 row">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          toggleModalUser()
                        }}
                        disabled={loadingSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <Button
                        type="submit"
                        color="success"
                        disabled={loadingSubmit}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </AvForm>
              </div>
            </Modal>
          </div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Media>
                    <div className="me-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <Media body className="align-self-center">
                      <div className="text-muted">
                        <h5>
                          {`${currentUser.first_name} ${currentUser.last_name}`}
                        </h5>
                        <p className="mb-1">{currentUser.email} </p>
                        <p className="mb-1">{currentUser.tel}</p>
                        <p className="mb-1">{currentUser.agent_name}</p>
                      </div>
                    </Media>
                  </Media>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Profile)
